import {Directive, HostListener, Input} from '@angular/core';

@Directive({
  selector: "button[ngxPrint]"
})
export class NgxPrintDirective {

  public _printStyle = [];

  /**
   *
   *
   * @memberof NgxPrintDirective
   */
  @Input() printSectionId: string;

  /**
   *
   *
   * @memberof NgxPrintDirective
   */
  @Input() printTitle: string;

  /**
   *
   *
   * @memberof NgxPrintDirective
   */
  @Input() useExistingCss = false;

  /**
   * A delay in milliseconds to force the print dialog to wait before opened. Default: 0
   *
   * @memberof NgxPrintDirective
   */
  @Input() printDelay: number = 0;

  /**
   *
   *
   * @memberof NgxPrintDirective
   */
  @Input()
  set printStyle(values: { [key: string]: { [key: string]: string } }) {
    for (let key in values) {
      if (values.hasOwnProperty(key)) {
        this._printStyle.push((key + JSON.stringify(values[key])).replace(/['"]+/g, ''));
      }
    }
    this.returnStyleValues();
  }

  /**
   *
   *
   * @returns the string that create the stylesheet which will be injected
   * later within <style></style> tag.
   *
   * -join/replace to transform an array objects to css-styled string
   *
   * @memberof NgxPrintDirective
   */
  public returnStyleValues() {
    return `<style> ${this._printStyle.join(' ').replace(/,/g, ';')} </style>`;
  }

  /**
   *
   *
   * @returns html for the given tag
   *
   * @memberof NgxPrintDirective
   */
  private _styleSheetFile = '';

  /**
   * @memberof NgxPrintDirective
   * @param cssList
   */
  @Input()
  set styleSheetFile(cssList: string) {
    let linkTagFn = function (cssFileName) {
      return `<link rel="stylesheet" type="text/css" href="${cssFileName}">`;
    }
    if (cssList.indexOf(',') !== -1) {
      const valueArr = cssList.split(',');
      for (let val of valueArr) {
        this._styleSheetFile = this._styleSheetFile + linkTagFn(val);
      }
    } else {
      this._styleSheetFile = linkTagFn(cssList);
    }
  }

  /**
   * @returns string which contains the link tags containing the css which will
   * be injected later within <head></head> tag.
   *
   */
  private returnStyleSheetLinkTags() {
    return this._styleSheetFile;
  }

  private getElementTag(tag: keyof HTMLElementTagNameMap): string {
    const html: string[] = [];
    const elements = document.getElementsByTagName(tag);
    for (let index = 0; index < elements.length; index++) {
      html.push(elements[index].outerHTML);
    }
    return html.join('\r\n');
  }

  /**
   * @returns html section to be printed along with some associated inputs
   *
   */
  private getHtmlContents() {
    let printContents: any = document.getElementById(this.printSectionId);
    let allInputControls: any = printContents.getElementsByTagName('input');
    let textareaControls: any = printContents.getElementsByTagName('textarea');
    let selectControls: any = printContents.getElementsByTagName('select');
    let radioControls: any = [];
    let checkboxControls: any = [];

    for (let i = 0; i < allInputControls.length; i++) {
      allInputControls[i].defaultValue = allInputControls[i].value;
      if (allInputControls[i].type === 'radio') {
        radioControls.push(allInputControls[i]);
      }

      if (allInputControls[i].type === 'checkbox') {
        checkboxControls.push(allInputControls[i]);
      }
    }

    for (let i = 0; i < textareaControls.length; i++) {
      textareaControls[i].defaultValue = textareaControls[i].value;
    }

    for (let i = 0; i < selectControls.length; i++) {
      const optionsInEachSelect: any = selectControls[i].getElementsByTagName('option');
      for (let j = 0; j < optionsInEachSelect.length; j++) {
        if (selectControls[i].value.toString() === optionsInEachSelect[j].value.toString()) {
          optionsInEachSelect[j].setAttribute('selected', '');
        } else {
          optionsInEachSelect[j].removeAttribute('selected');
        }
      }
    }

    for (let i = 0; i < radioControls.length; i++) {
      if (radioControls[i].checked === true) {
        radioControls[i].setAttribute('checked', '');
      } else {
        radioControls[i].removeAttribute('checked');
      }
    }

    for (let i = 0; i < checkboxControls.length; i++) {
      if (checkboxControls[i].checked === true) {
        checkboxControls[i].setAttribute('checked', '');
      } else {
        checkboxControls[i].removeAttribute('checked');
      }
    }

    return printContents.innerHTML;
  }

  /**
   *
   *
   * @memberof NgxPrintDirective
   */
  @HostListener('click')
  public print(): void {
    let printContents, popupWin, styles = '', links = '';

    if (this.useExistingCss) {
      styles = this.getElementTag('style');
      links = this.getElementTag('link');
    }

    printContents = this.getHtmlContents();

    popupWin = window.open("", "_blank", "top=0,left=0,height=auto,width=auto");
    popupWin.document.write(`
      <html>
        <head>
          <title>${this.printTitle ? this.printTitle : ""}</title>
          ${this.returnStyleValues()}
          ${this.returnStyleSheetLinkTags()}
          ${styles}
          ${links}
        </head>
        <body>
          ${printContents}

        </body>
      </html>`);

    setTimeout(() => {
      popupWin.document.close();
      popupWin.focus();
      popupWin.print();
      popupWin.close();
    }, 250);


  }
}
